import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { Invoice } from 'contracts/Invoice';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_PENDING_RELEASE_',
  }
);

export interface FetchPendingReleaseState {
  data: Invoice | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchPendingReleaseRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: Invoice;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchPendingReleaseState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchPendingReleaseState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchPendingReleaseState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchPendingReleaseState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchPendingReleaseState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchPendingRelease = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchPendingReleaseTypes = Types;
export const FetchPendingReleaseActions = Creators;
